export let routes = [
  {
    path: '/x3-side-belonger',
    name: 'x3-side-belonger',
    component: () => import('./belonger.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsBelonger(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-belonger',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
